import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';

import ButtonDisclosures from '../../../atoms/button-disclosures';
import TableBasic from '../../../atoms/table-basic/index';
import CardModule from '../../shared/card-module';
import format from '../../../../utils/format';
import { augment } from '../../../../utils/GlobalCssProxy';
import contractFeesText from '../../../../helpers/statics/contract-fees-text';

import styles from './contract-fees.module.scss';
const s = augment(styles);

const ContractFees = ({ feeType, heading, dateOptions }) => {
  const totalContractFee =
    feeType.administrativeDeclaredFee +
    feeType.grossUpDeclaredFee +
    feeType.grossDownDeclaredFee +
    feeType.discontinuanceDeclaredFee;
  return (
    <CardModule
      data-analytics-componenttype="third-width-component"
      data-analytics-id="TW_ContractFees"
      data-analytics-section="component"
    >
      <CardModule.Header>
        {heading}
        <CardModule.AsOfDate>
          {format.date(feeType.priceDate, dateOptions)}
        </CardModule.AsOfDate>
      </CardModule.Header>
      <CardModule.Body>
        <Row as="section" className={s('mt-2', 'mb-2', 'ml-1', 'mr-1')}>
          <p className={s('paragraph-standard')}>{contractFeesText.summary}</p>
        </Row>
        <Row className={s('ml-1', 'mr-1')}>
          <TableBasic className={s('table')}>
            <caption className={s('sr-only')}>
              Contract Fees for stable value
            </caption>
            <thead>
              <tr>
                <th scope="row" colSpan="2">
                  Fee Type
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">Administrative Fee</th>
                <td className={s('text-right')}>
                  {format.number(feeType.administrativeDeclaredFee)}
                </td>
              </tr>
              <tr>
                <th scope="row">Gross-up Fee</th>
                <td className={s('text-right')}>
                  {format.number(feeType.grossUpDeclaredFee)}
                </td>
              </tr>
              <tr>
                <th scope="row">Gross Down Credit</th>
                <td className={s('text-right')}>
                  {format.number(feeType.grossDownDeclaredFee)}
                </td>
              </tr>
              <tr>
                <th scope="row">Discontinuance Fee</th>
                <td className={s('text-right')}>
                  {format.number(feeType.discontinuanceDeclaredFee)}
                </td>
              </tr>
              <tr>
                <th scope="row">Total Contract Fee</th>
                <td className={s('text-right')}>
                  {format.number(totalContractFee)}
                </td>
              </tr>
            </tbody>
          </TableBasic>
        </Row>
      </CardModule.Body>
      <CardModule.Footer className={s('text-right')}>
        <ButtonDisclosures module={'contract-fees'} />
      </CardModule.Footer>
    </CardModule>
  );
};

ContractFees.defaultProps = {
  feeType: {},
  heading: 'Contract Fees'
};

ContractFees.propTypes = {
  feeType: PropTypes.shape({
    administrativeDeclaredFee: PropTypes.number,
    discontinuanceDeclaredFee: PropTypes.number,
    grossUpDeclaredFee: PropTypes.number,
    grossDownDeclaredFee: PropTypes.number,
    priceDate: PropTypes.string
  }),
  heading: PropTypes.string,
  dateOptions: PropTypes.object
};

export default ContractFees;
